/* marathon-site-agents ─ two small jobs, no dependencies, nothing personal.
   1. VIEWS: an anonymous view sequence (random session id kept in
      sessionStorage, product handle, time, referrer type) is beaconed to the
      shop's own collector so "looked at together" can be counted. No cookies,
      no customer data, and automated visitors (the site's own shopper agents
      included) are skipped.
   2. GOES WELL WITH: when the quick-view panel opens, its "Goes well with" row
      is fetched from /products/{handle}?view=msa-pairs (rendered from the
      product's complementary-products metafield) and shown if there is one. */
(function () {
  var cfg = window.MSA || {};
  var BOT = /MarathonShopperAgent|MarathonSiteAgents|bot|crawl|spider|Lighthouse|HeadlessChrome/i.test(navigator.userAgent);

  function sessionId() {
    try {
      var s = sessionStorage.getItem("msa-sid");
      if (!s) { s = Math.random().toString(36).slice(2, 12) + Date.now().toString(36); sessionStorage.setItem("msa-sid", s); }
      return s;
    } catch (e) { return null; }
  }
  function referrerType() {
    var r = document.referrer;
    if (!r) return "direct";
    try {
      var h = new URL(r).hostname;
      if (h === location.hostname) return "internal";
      if (/instagram|facebook|fb\.|tiktok|whatsapp|t\.co$|twitter|x\.com/.test(h)) return "social";
      if (/google|bing|yahoo|duckduckgo/.test(h)) return "search";
      return "other";
    } catch (e) { return "other"; }
  }
  var last = null;
  function view(handle) {
    if (BOT || !cfg.collector || !handle || handle === last) return;
    last = handle;
    var sid = sessionId();
    if (!sid) return;
    var body = JSON.stringify({ sid: sid, h: handle, t: Date.now(), r: referrerType() });
    try { if (navigator.sendBeacon && navigator.sendBeacon(cfg.collector, new Blob([body], { type: "text/plain" }))) return; } catch (e) { /* fall through */ }
    try { fetch(cfg.collector, { method: "POST", body: body, keepalive: true, mode: "no-cors", headers: { "Content-Type": "text/plain" } }); } catch (e) { /* analytics never breaks the page */ }
  }
  function handleOf(url) { var m = /\/products\/([a-z0-9-]+)/.exec(url || ""); return m ? m[1] : null; }

  var loaded = {};
  function loadPairs(card, handle) {
    var box = card.querySelector("[data-msa-pairs]");
    if (!box || !handle || loaded[handle]) return;
    loaded[handle] = true;
    fetch("/products/" + handle + "?view=msa-pairs", { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.text() : ""; })
      .then(function (html) { if (html.indexOf("msa-pairs__item") > -1) { box.innerHTML = html; box.hidden = false; } })
      .catch(function () { /* the row is optional */ });
  }

  if (cfg.product) view(cfg.product);
  document.addEventListener("click", function (ev) {
    var opener = ev.target.closest && ev.target.closest("[data-mc-open]");
    if (!opener) return;
    var card = opener.closest("[data-mc-card]");
    if (!card) return;
    var handle = handleOf(card.getAttribute("data-mc-url"));
    setTimeout(function () {
      var panel = card.querySelector("[data-mc-panel]");
      if (panel && !panel.hidden) { view(handle); loadPairs(card, handle); }
    }, 60);
  });
})();
